import rabbit from 'rabbit-node';
import knayi from 'knayi-myscript';

export function isZawgyi(str){
	return knayi.fontDetect(str) === 'zawgyi';
}

export function fromUnicodeToZawgyi(str){
	return isZawgyi(str) ? str : rabbit.uni2zg(str);
}

export function fromZawgyiToUnicode(str){
	return isZawgyi(str) ? rabbit.zg2uni(str) : str;
}

